<template>
<div  class="ignore wrap justify-center align-center in-front">

    <v-snackbar light  max-width="100" multi-line :timeout="-1" centered top :value="snackbar" outlined >
        <p class="pt-2 pb-2"> You are about rename the {{route === 'collections'? 'file': 'location group'}} for everyone in your organization.
            </p>
    <div class="d-flex buttons in-front">


        <v-btn @click="submit(item)">Proceed</v-btn>

        <v-btn class="ml-15" @click="hideForm()">Go Back</v-btn>
    </div>
    </v-snackbar>
      <v-form ref="form"
               :id="item.formId"
              :class="['form']"

              @submit="runSubmission(item)" >

              <v-text-field
                hide-details
              v-model="item.name"


            >

            </v-text-field>


            </v-form>

            <div :class="['d-flex', 'container']">

            <v-checkbox v-model="item.is_shared_with_account"  hide-details class="align-center justify-center checkbox">
                <template v-slot:label>
    <span :style="`font-size: ${xSmall? '10px': '16px'}`">Share with your organization</span>
  </template>
            </v-checkbox>

            <v-btn :x-small="xSmall" text :color="textColor" @click="runSubmission(item)">
                Update
            </v-btn>
            </div>

</div>
</template>

<script>


export default {

name: 'EditingForm',
data(){
    return {
        prevName: '',
        snackbar: false
    }
},
mounted(){
    //storing the initial name for undo functionality
    this.prevName = this.item.name
},
props: ['item', 'update', 'id', 'color', 'xSmall', 'route'],
methods:{
    hideForm(){

        //we shouldn't need the ||, but in case we somehow fail to store prevName it's better to change the name to the new name instead of an empty string
        this.item.name = this.prevName||this.item.name;
        this.$emit('hideForm');

    },
    runSubmission(item){
        let nameHasChanged = this.prevName !== this.item.name
       return nameHasChanged && item.is_shared_with_account? this.snackbar = true: this.update(item)
    },
    submit(item){
        this.update(item)
    }
},
computed: {
     textColor(){
       return this.color || 'blue'
    }
},
watch: {
    checked(newVal){

    }
}

}
</script>

<style scoped>

.v-input--selection-controls{
    margin-top:0;
}
.container{
    gap:20px;
}
.container{
    align-items:center;
    gap: 20px;
    text-align:center;
    padding-top:5px;
}

::v-deep .checkbox .v-label{
    font-size: 10px !important;
}

.wrap{
    white-space: normal;
}

::v-deep .v-snack__content{
    padding: 15px !important;
    text-align:center;
}

.buttons{
    justify-content: flex-end;
}

.in-front{
    z-index:100;
}

</style>

<style  >
.container .v-input__slot{
    margin-bottom: 0 !important;
    margin-top: 0 !important
}
</style>
